import { Component, input } from '@angular/core';

@Component({
  selector: 'ziro-self-serve-user-details-header',
  templateUrl: './self-serve-user-details-header.component.html',
  standalone: false,
})
export class SelfServeUserDetailsHeaderComponent {
  readonly heading = input<string>();
  readonly headingDataAutomation = input<string>();
}
